import Link from '@/_application/core/components/ui/link';
import {useHotSearchKeyWords} from '@/framework/category';
import rangeMap from '@/lib/range-map';
import ContentLoader from 'react-content-loader';
import {convertUrlToNewSite} from '@/_application/core/utils/convert-url';

interface IProps {
    categoryId: number;
}

function HotSearchKeyWords({categoryId}: Readonly<IProps>) {
    const {data, isLoading} = useHotSearchKeyWords(categoryId);

    return (
        <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-4 px-[22px]">
            {data.length > 0 && <h3 className="font-bold text-primary">Được tìm kiếm nhiều</h3>}
            {isLoading ? (
                rangeMap(3, i => (
                    <ContentLoader
                        key={i}
                        speed={2}
                        width={128}
                        height={28}
                        viewBox="0 0 128 28"
                        backgroundColor="#e0e0e0"
                        foregroundColor="#cecece">
                        <rect x="0" y="0" rx="12" ry="12" width="128" height="28" />
                    </ContentLoader>
                ))
            ) : data.length ? (
                data.map(item => (
                    <Link
                        href={convertUrlToNewSite(item?.tag_url!)}
                        key={item?.tag_id}
                        className="rounded-full bg-white px-4 py-1 text-sm font-light text-primary shadow-productCard transition-colors hover:bg-KPZ_Xanh_Nhat">
                        {item?.tag_title}
                    </Link>
                ))
            ) : (
                <></>
            )}
        </div>
    );
}

export default HotSearchKeyWords;
